<div>
    <a href="{{href}}" class="featureTile" data-product-id="{{id}}">
        {{#each images}}
            {{#if isPrimary}}
                <picture class="featureTile-img">
                    <source media="(max-width: 1023px)" width="450" height="450" srcset="https://smartpress.imgix.net{{src}}?w=450&h=450&fit=crop&auto=format,compress">
                    <source media="(min-width: 1024px)" width="600" height="600" srcset="https://smartpress.imgix.net{{src}}?w=600&h=600&fit=crop&auto=format,compress">
                    <img loading="lazy" alt="{{alt}}" width="600" height="600" src="https://smartpress.imgix.net{{src}}?w=600&h=600&fit=crop&auto=format,compress">
                </picture>
            {{/if}}
        {{/each}}
        <div class="featureTile-cta">
            <h3 class="lbl lbl_lg lbl_bold lbl_brand">{{name}}</h3>
            <span class="link link_carrot">shop now</span>
        </div>
    </a>
</div>
